import React, { useEffect, useState } from "react";
import { ArrowForward, Close, FilterList } from "@mui/icons-material";
import TableComponent from "../TableComponent";
import httpclient from "../../../Utils";
import {
  Box,
  Button,
  Card,
  Collapse,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  styled,
  TextField,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import useTokenRefresh from "../../../Hooks/useTokenRefresh";
import Footer from "../../../Components/Footer";
import { useBranch } from "../../../Hooks/useBranch";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const columns = [
  { id: "sn", name: "SN" },
  { id: "user_name", name: "User Name" },
  { id: "user_type", name: "User Type" },
  { id: "ip_address", name: "IP Address" },
  { id: "logout_date", name: "Logout Date" },
  { id: "logout_type", name: "Logout Type" },
  { id: "log_message", name: "Log Message" },
];

const FilteredBox = styled(Box)(({ theme }) => ({
  background: "#f9f9f9",
  padding: "5px 10px",
  borderRadius: "5px",
  "& p": {
    margin: "3px 0",
    marginRight: "10px",
    display: "inline-block",
    background: "#dedede",
    borderRadius: "10px",
    padding: "2px 5px",
  },
  "& svg": {
    fontSize: "15px",
    cursor: "pointer",
    position: "relative",
    top: "3px",
    background: theme.palette.primary.dark,
    color: "#fff",
    borderRadius: "50%",
    padding: "2px",
    marginLeft: "2px",
  },
}));

const Header = styled("div")(({ theme }) => ({
  "& h1": {
    color: theme.palette.primary.dark,
    margin: "0",
  },
}));

const logoutConfigRowPerPage = JSON.parse(
  localStorage.getItem("logoutConfigRowPerPage")
);

const LogoutLogs = (props) => {
  const {
    getTokenRefreshed: refresh,
    open: tokenOpen,
    overlay: overlay,
    setOpen: setTokenOpen,
    message: tokenMessage,
    messageState: tokenMessageState,
  } = useTokenRefresh();

  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [viewDetails, setViewDetails] = useState({});
  const [rows, setRows] = useState([]);
  const [rowChecked, setRowChecked] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleLoading, setSingleLoading] = useState(false);
  const [direction, setDirection] = useState(false);
  const [logoutTypeOptions, setLogoutTypeOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [currentColumn, setCurrentColumn] = useState("");
  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [to, setTo] = useState(
    logoutConfigRowPerPage && logoutConfigRowPerPage
      ? logoutConfigRowPerPage && logoutConfigRowPerPage
      : 20
  );

  const [rowsPerPage, setRowsPerPage] = useState(
    logoutConfigRowPerPage && logoutConfigRowPerPage
      ? logoutConfigRowPerPage && logoutConfigRowPerPage
      : 20
  );
  const [total, setTotal] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);
  const { currentBranch } = useBranch();

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [messageState, setMessageState] = useState("");

  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    logoutType: "",
    userId: "",
    remove: false,
  });

  const [submittedData, setSubmittedData] = useState({
    startDate: "",
    endDate: "",
    logoutType: "",
    userId: "",
    submit: false,
  });

  useEffect(() => {
    if (
      filterData.startDate === "" ||
      filterData.endDate === "" ||
      filterData.logoutType === "" ||
      filterData.userId === ""
    ) {
      setSubmittedData({
        ...submittedData,
        submit: false,
      });
    }

    if (filterData.startDate === " ") filterData.startDate = "";
    if (filterData.endDate === " ") filterData.endDate = "";
    if (filterData.logoutType === " ") filterData.logoutType = "";
    if (filterData.userId === " ") filterData.userId = "";

    filterData.remove === true && handleFilter();
  }, [filterData]);

  useEffect(() => {
    let currentpolicy = JSON.parse(localStorage.getItem("audit_logout_logs"));
    currentpolicy !== null && setFilterData(currentpolicy);
    if (currentpolicy) {
      setFilterData((prev) => ({
        startDate: "",
        endDate: "",
        logoutType: "",
        userId: "",
        ...currentpolicy,
        remove: true, // Trigger handleFilter
      }));
      setSubmittedData({
        // Also update submittedData to reflect loaded filters
        startDate: currentpolicy.startDate || "",
        endDate: currentpolicy.endDate || "",
        logoutType: currentpolicy.logoutType || "",
        userId: currentpolicy.userId || "",
        submit: true,
      });
    } else {
      getLogoutLogs();
    }
  }, [currentBranch]);

  const getLogoutLogs = () => {
    setLoading(true);
    httpclient
      .get(`audit/logout-logs?pagination=${rowsPerPage}&page=${page}`)
      .then(({ data: responseData }) => {
        if (responseData.status === 200) {
          setRows(responseData.data);
          setTotal(responseData.meta.total);
          setRowsPerPage(parseInt(responseData.meta.per_page));
          setPage(responseData.meta.current_page);
          setFrom(responseData.meta.from);
          setTo(responseData.meta.to);
          setLogoutTypeOptions(responseData.logOutTypes || []);
          setUserOptions(responseData.users || []);
          setLoading(false);
        } else {
          setOpen(true);
          setMessage(responseData.message);
          setMessageState("error");
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          refresh();
          setOpen(tokenOpen);
          setMessage(tokenMessage);
          setMessageState("error");
        } else if (err.response.status === 422) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else if (err.response.status === 400) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else {
          setOpen(true);
          setMessage(err.response.data.message);
          setMessageState("error");
          setLoading(false);
        }
      });
  };

  const handleView = (row) => {
    setSingleLoading(true);
    setOpenViewDialog(true);
    httpclient
      .get(`audit/logout-logs/${row.id || row}`)
      .then(({ data }) => {
        if (data) {
          setViewDetails(data.data);
          setSingleLoading(false);
        } else {
          setOpen(true);
          setMessage(data.message);
          setMessageState("error");
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          refresh();
          setOpen(tokenOpen);
          setMessage(tokenMessage);
          setMessageState("error");
        } else if (err.response.status === 422) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else if (err.response.status === 400) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else {
          setOpen(true);
          setMessage(err.response.data.message);
          setMessageState("error");
          setLoading(false);
        }
      });
  };

  const handleFilter = () => {
    setSubmittedData({
      ...submittedData,
      startDate: filterData.startDate,
      endDate: filterData.endDate,
      logoutType: filterData.logoutType,
      userId: filterData.userId,
      submit: true,
    });

    const filtersToSave = {
      startDate: filterData.startDate,
      endDate: filterData.endDate,
      logoutType: filterData.logoutType,
      userId: filterData.userId,
    };
    localStorage.setItem("audit_logout_logs", JSON.stringify(filtersToSave));
    setLoading(true);

    const queryParams = new URLSearchParams();
    queryParams.set("pagination", rowsPerPage);
    queryParams.set("page", 1); // Reset to page 1 on new filter

    if (filterData.startDate && filterData.endDate) {
      queryParams.set(
        "filters[logout_date][$between][0]",
        filterData.startDate
      );
      queryParams.set("filters[logout_date][$between][1]", filterData.endDate);
    }
    if (filterData.logoutType) {
      queryParams.set("filters[logout_type][$eq]", filterData.logoutType);
    }
    if (filterData.userId) {
      queryParams.set("filters[user_id][$eq]", filterData.userId);
    }

    if (
      filterData.startDate ||
      filterData.endDate ||
      filterData.logoutType ||
      filterData.userId
    ) {
      httpclient
        .get(`audit/logout-logs?${queryParams.toString()}`)
        .then(({ data: responseData }) => {
          if (responseData.status === 200) {
            setRows(responseData.data);
            setTotal(responseData.meta.total);
            setRowsPerPage(parseInt(responseData.meta.per_page));
            setPage(responseData.meta.current_page);
            setFrom(responseData.meta.from);
            setTo(responseData.meta.to);
            setLogoutTypeOptions(responseData.logOutTypes || []);
            setUserOptions(responseData.users || []);
            setLoading(false);
          } else {
            setOpen(true);
            setMessage(responseData.message);
            setMessageState("error");
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            refresh();
            setOpen(tokenOpen);
            setMessage(tokenMessage);
            setMessageState("error");
          } else if (err.response.status === 422) {
            const errorMessages = Object?.values(
              err.response.data.errors
            ).flat();
            setOpen(true);
            setMessage(errorMessages);
            setMessageState("error");
            setLoading(false);
          } else if (err.response.status === 400) {
            const errorMessages = Object?.values(
              err.response.data.errors
            ).flat();
            setOpen(true);
            setMessage(errorMessages);
            setMessageState("error");
            setLoading(false);
          } else {
            setOpen(true);
            setMessage(err.response.data.message);
            setMessageState("error");
            setLoading(false);
          }
        });
    } else {
      getLogoutLogs(); // This will also set options
    }
  };

  const hadleFilterOpen = () => {
    setFilterOpen((prev) => !prev);
  };

  const handleChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilterData({
      ...filterData,
      [name]: value,
      remove: false,
    });
  };

  const handleRemove = (data) => {
    if (data === "dateRange") {
      setFilterData({
        ...filterData,
        startDate: "",
        endDate: "",
        remove: true,
      });
      setSubmittedData({
        ...submittedData,
        startDate: "",
        endDate: "",
      });
    } else {
      setFilterData((prev) => ({ ...prev, [data]: "", remove: true }));
      setSubmittedData((prev) => ({ ...prev, [data]: "" }));
    }
  };

  const handleSort = (column) => {
    setDirection((prevDirection) => !prevDirection);
    setCurrentColumn(column);
    setLoading(true);
    submittedData.submit
      ? (() => {
          const queryParams = new URLSearchParams();
          if (filterData.startDate && filterData.endDate) {
            queryParams.set(
              "filters[logout_date][$between][0]",
              filterData.startDate
            );
            queryParams.set(
              "filters[logout_date][$between][1]",
              filterData.endDate
            );
          }
          if (filterData.logoutType)
            queryParams.set("filters[logout_type][$eq]", filterData.logoutType);
          if (filterData.userId)
            queryParams.set("filters[user_id][$eq]", filterData.userId);
          queryParams.set(
            "sort[0]",
            `${column}:${!direction ? "asc" : "desc"}`
          );
          queryParams.set("pagination", rowsPerPage);
          queryParams.set("page", page);

          httpclient
            .get(`audit/logout-logs?${queryParams.toString()}`)
            .then(({ data: responseData }) => {
              if (responseData.status === 200) {
                setRows(responseData.data);
                setTotal(responseData.meta.total);
                setRowsPerPage(parseInt(responseData.meta.per_page));
                setPage(responseData.meta.current_page);
                setFrom(responseData.meta.from);
                setTo(responseData.meta.to);
                // Note: Options (logOutTypes, users) might not be in sort response,
                // ideally they are fetched once or if API provides them consistently.
                // For now, assuming they are stable after initial load/filter.
                setLoading(false);
              } else {
                setOpen(true);
                setMessage(responseData.message);
                setMessageState("error");
                setLoading(false);
              }
            })
            .catch((err) => {
              /* ... error handling ... */ setLoading(false);
            });
        })()
      : httpclient
          .get(
            `audit/logout-logs?sort[0]=${column}:${
              !direction ? "asc" : "desc"
            }&pagination=${rowsPerPage}&page=${page}`
          )
          .then(({ data: responseData }) => {
            if (responseData.status === 200) {
              setRows(responseData.data);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(responseData.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            /* ... error handling ... */ setLoading(false);
          });
  };

  const handleChangePage = (e, page) => {
    setLoading(true);
    submittedData.submit
      ? (() => {
          const queryParams = new URLSearchParams();
          if (filterData.startDate && filterData.endDate) {
            queryParams.set(
              "filters[logout_date][$between][0]",
              filterData.startDate
            );
            queryParams.set(
              "filters[logout_date][$between][1]",
              filterData.endDate
            );
          }
          if (filterData.logoutType)
            queryParams.set("filters[logout_type][$eq]", filterData.logoutType);
          if (filterData.userId)
            queryParams.set("filters[user_id][$eq]", filterData.userId);
          if (currentColumn)
            queryParams.set(
              "sort[0]",
              `${currentColumn}:${direction ? "asc" : "desc"}`
            );
          queryParams.set("pagination", rowsPerPage);
          queryParams.set("page", page);

          httpclient
            .get(`audit/logout-logs?${queryParams.toString()}`)
            .then(({ data: responseData }) => {
              if (responseData.status === 200) {
                setRows(responseData.data);
                setTotal(responseData.meta.total);
                setRowsPerPage(parseInt(responseData.meta.per_page));
                setPage(responseData.meta.current_page);
                setFrom(responseData.meta.from);
                setTo(responseData.meta.to);
                setLoading(false);
              } else {
                setOpen(true);
                setMessage(responseData.message);
                setMessageState("error");
                setLoading(false);
              }
            })
            .catch((err) => {
              /* ... error handling ... */ setLoading(false);
            });
        })()
      : httpclient
          .get(
            `audit/logout-logs?${
              currentColumn
                ? `&sort[0]=${currentColumn}:${direction ? "asc" : "desc"}`
                : ""
            }&pagination=${rowsPerPage}&page=${page}`
          )
          .then(({ data: responseData }) => {
            if (responseData.status === 200) {
              setRows(responseData.data);
              setTotal(responseData.meta.total);
              setRowsPerPage(parseInt(responseData.meta.per_page));
              setPage(responseData.meta.current_page);
              setFrom(responseData.meta.from);
              setTo(responseData.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(responseData.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            /* ... error handling ... */ setLoading(false);
          });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setLoading(true);

    localStorage.setItem("logoutConfigRowPerPage", event.target.value);

    submittedData.submit
      ? (() => {
          const queryParams = new URLSearchParams();
          if (filterData.startDate && filterData.endDate) {
            queryParams.set(
              "filters[logout_date][$between][0]",
              filterData.startDate
            );
            queryParams.set(
              "filters[logout_date][$between][1]",
              filterData.endDate
            );
          }
          if (filterData.logoutType)
            queryParams.set("filters[logout_type][$eq]", filterData.logoutType);
          if (filterData.userId)
            queryParams.set("filters[user_id][$eq]", filterData.userId);
          if (currentColumn)
            queryParams.set(
              "sort[0]",
              `${currentColumn}:${direction ? "asc" : "desc"}`
            );
          queryParams.set("pagination", +event.target.value);
          queryParams.set("page", page); // Or page 1 if rowsPerPage changes? Usually current page

          httpclient
            .get(`audit/logout-logs?${queryParams.toString()}`)
            .then(({ data: responseData }) => {
              if (responseData.status === 200) {
                setRows(responseData.data);
                setTotal(responseData.meta.total);
                setRowsPerPage(parseInt(responseData.meta.per_page));
                setPage(responseData.meta.current_page);
                setFrom(responseData.meta.from);
                setTo(responseData.meta.to);
                setLoading(false);
              } else {
                setOpen(true);
                setMessage(responseData.message);
                setMessageState("error");
                setLoading(false);
              }
            })
            .catch((err) => {
              /* ... error handling ... */ setLoading(false);
            });
        })()
      : httpclient
          .get(
            `audit/logout-logs?${
              currentColumn
                ? `&sort[0]=${currentColumn}:${direction ? "asc" : "desc"}`
                : ""
            }&pagination=${+event.target.value}&page=${1}`
          )
          .then(({ data: responseData }) => {
            if (responseData.status === 200) {
              setRows(responseData.data);
              setTotal(responseData.meta.total);
              setRowsPerPage(parseInt(responseData.meta.per_page));
              setFrom(responseData.meta.from);
              setTo(responseData.meta.to);
              setPage(responseData.meta.current_page);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(responseData.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            /* ... error handling ... */ setLoading(false);
          });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setTokenOpen(false);
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={8} xs={12}>
          <Header>
            <h1>List Logout Logs</h1>
          </Header>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button color="primary" variant="contained" onClick={hadleFilterOpen}>
            Filter <FilterList style={{ marginLeft: "5px" }} fontSize="small" />
          </Button>
        </Grid>

        {/* Filter */}
        <Grid item xs={12}>
          <Collapse in={filterOpen}>
            <Card>
              <Box p={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Start Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="startDate"
                      type="date"
                      value={filterData.startDate}
                      onChange={(e) => handleChangeFilter(e)}
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <InputLabel>End Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="endDate"
                      type="date"
                      value={filterData.endDate}
                      onChange={(e) => handleChangeFilter(e)}
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <InputLabel>Logout Type</InputLabel>
                    <FormControl fullWidth>
                      <Select
                        name="logoutType"
                        value={filterData.logoutType}
                        onChange={handleChangeFilter}
                      >
                        {logoutTypeOptions &&
                          logoutTypeOptions.map((option) => (
                            <MenuItem key={option.code} value={option.code}>
                              {option.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <InputLabel>User</InputLabel>
                    <FormControl fullWidth>
                      <Select
                        name="userId"
                        value={filterData.userId}
                        onChange={handleChangeFilter}
                      >
                        {userOptions &&
                          userOptions.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Box textAlign={"right"}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleFilter}
                      >
                        Filter{" "}
                        <ArrowForward
                          fontSize="small"
                          style={{ marginLeft: "5px" }}
                        />
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Collapse>
        </Grid>

        {submittedData.submit &&
        (submittedData.startDate ||
          submittedData.endDate ||
          submittedData.logoutType ||
          submittedData.userId) ? (
          <Grid item xs={12}>
            <FilteredBox>
              <span>Filtered: </span>

              {(submittedData.startDate || submittedData.endDate) && (
                <p>
                  <span>
                    Logout Date Range: {submittedData.startDate} -{" "}
                    {submittedData.endDate}
                  </span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("dateRange")}
                  />
                </p>
              )}
              {submittedData.logoutType && (
                <p>
                  <span>
                    Logout Type:{" "}
                    {logoutTypeOptions.find(
                      (opt) => opt.code === submittedData.logoutType
                    )?.name || submittedData.logoutType}
                  </span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("logoutType")}
                  />
                </p>
              )}
              {submittedData.userId && (
                <p>
                  <span>
                    User:{" "}
                    {userOptions.find((opt) => opt.id === submittedData.userId)
                      ?.name || submittedData.userId}
                  </span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("userId")}
                  />
                </p>
              )}
            </FilteredBox>
          </Grid>
        ) : (
          <Box></Box>
        )}
        {/* Filter */}

        <Grid item xs={12}>
          <TableComponent
            columns={columns}
            rows={rows}
            sort={true}
            //handleView={handleView}
            handleSort={handleSort}
            loading={loading}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            rowChecked={rowChecked}
            buttonLoader={buttonLoader}
            direction={direction}
            currentColumn={currentColumn}
            page={page}
            total={total && total}
            fromTable={from}
            toTable={to}
            rowsPerPage={rowsPerPage}
            filterData={filterData}
          />
        </Grid>
        <Footer overlay={overlay || props.overlayNew} />
      </Grid>

      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open || tokenOpen}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={messageState || tokenMessageState}
          sx={{ width: "100%" }}
        >
          {message || tokenMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default LogoutLogs;
